// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1wufI","form":"styles_form__b9VHa"};